import {AppDispatch, RootState} from "../store/store";
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import noImg from './../assets/img/noPhoto.png'
import Fraction from "fraction.js";
import {
    AngleType,
    AttrItemType,
    CustomPartDataType,
    CustomPartType,
    hingeArr,
    materialsCustomPart,
    MaybeEmpty,
    MaybeNull,
    MaybeUndefined,
    pricePart,
    ProductApiType,
    productCategory,
    productRangeType,
    ProductType,
    productTypings,
    ProductFormType,
    sizeLimitsType,
    valueItemType,
    ProductOrCustomType,
    ProductTableDataType,
    CustomPartTableDataType,
    InitialSizesType,
    LedAccessoriesFormType,
    hingeTypes,
    AttrWithoutDescType,
    materialsLimitsType,
    CustomPartMaterialsArraySizeLimitsType,
    ProductOptionsType,
    materialDataType,
    LEDType,
    FinishSidesTypes, ProductExtraType,
} from "./productTypes";
import {optionType, optionTypeDoor} from "../common/SelectField";
import cabinets from '../api/cabinets.json';
import {
    calculateProduct, getBoxMaterialCoefByColorType, getBoxMaterialColorType,
    getCustomPartPrice,
    getMaterialData,
    getProductDataToCalculatePrice,
    getProductPriceRange,
    getProductRange, getSizeLimitsFromData
} from "./calculatePrice";
import sizes from "../api/sizes.json";
import {MaterialStringsType} from "../common/Materials";
import {
    CustomPartFormType, CustomPartShelvesType,
    DoorAccessoryAPIType,
    DoorAccessoryFront,
    DoorAccessoryType, HingesOrHolesType, PanelAccessoriesType, PanelCutoutType, RTAClosetAPIType, RTAPartCustomType,
} from "../Components/CustomPart/CustomPart";
import {initialDoorAccessories} from "../Components/CustomPart/CustomPartDoorAccessoiresForm";
import {
    DoorSizesArrType,
    DoorType,
} from "../Components/CustomPart/CustomPartStandardDoorForm";
import standardColors from '../api/standardColors.json'
import {CatItem, SliderCategoriesItemType, SliderCategoriesType} from './categoriesTypes';
import categoriesData from "../api/categories.json";
import DA from '../api/doorAccessories.json'
import {initialStandardPanels} from "../Components/CustomPart/CustomPartStandardPanel";
import settings from "../api/settings.json";
import {
    CartAPI, CartCustomTypeAPI,
    CartItemFrontType,
    CartOrder, IsStandardDimentionsType, IsStandardOptionsType,
    LEDAccessoriesType, PanelAccessoriesTypeAPI
} from "./cartTypes";
import {
    colorType, CustomPartsImgListItem, DataToJSONType, doorType, DoorTypesType, DrawerAPIType,
    finishNames, finishType, FinishTypes,
    GolaType,
    GolaTypesType, materialsData,
    RoomCategoriesType,
    RoomFront,
    RoomMaterialsFormType, RoomNewType,
    RoomOrderType,
    RoomType
} from "./roomTypes";
import {PurchaseOrderType} from "../store/reducers/purchaseOrderSlice";
import {initialLEDAccessories} from "../Components/CustomPart/CustomPartLEDForm";
import {numericQuantity, NumericQuantityOptions} from "numeric-quantity";
import {AnyObject, TestContext} from "yup";
import {BorderType} from "../Components/Product/ProductLED";
import {
    CustomPartDoublePanel, CustomPartDoublePanelKeyType,
    CustomPartDoublePanelType,
    CustomPartShelves,
    CustomPartShelvesEnumType,
    getKeyByValue, getValueByKey
} from "./Enums";
import {UserType} from "../api/apiTypes";
import {CheckoutFormType} from "../Components/Checkout/CheckoutForm";

export const urlRegex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch: () => AppDispatch = useDispatch;


export function NumericQuantityRounded(
    value: string | number,
    options: NumericQuantityOptions = {}
) {
    return numericQuantity(value, {
        round: 5,
        ...options,
    });
}

export const getImg = (folder: string, img: MaybeUndefined<string>): string => {
    if (!folder || !img) return noImg;
    try {
        return require(`./../assets/img/${folder}/${img}`)
    } catch (e) {
        return noImg
    }
}

export const getImgOrNull = (folder: string, img: MaybeUndefined<string>): MaybeNull<string> => {
    if (!folder || !img) return null;
    try {
        return require(`./../assets/img/${folder}/${img}`)
    } catch (e) {
        return null
    }
}

export const getProductImg = (folder: string, name: string, hinge_postfix: string = '',): string => {
    for (const s of [hinge_postfix, '', 'L', '2L', '4'] as const) {
        try {
            const postfix = s ? `${name} ${s}.jpg` : `${name}.jpg`;
            return require(`./../assets/img/products/${folder}/${postfix}`);
        } catch (error) {
            continue;
        }
    }
    const glass_sbstr = '/glass';
    if (folder.includes(glass_sbstr)) {
        return getProductImg(folder.replace(glass_sbstr, ''), name, hinge_postfix);
    }
    return noImg;
}

const getProductImgSrc = (name: string, hinge_type: MaybeUndefined<hingeTypes>): [string, string] => {
    const n = name.replace(' Series', '');
    switch (hinge_type) {
        case "Left":
        case "Single left door":
            return [n, 'L']
        case "Right":
        case "Single right door":
            return [n, 'R']
        case "Two left doors":
            return [n, '2L']
        case "Two right doors":
            return [n, '2R']
        case "Four doors":
            return [n, '4']
        default:
            return [n, '']
    }
}

export const getCategoryImg = (room: RoomFront, currentCat: CatItem, hover?: MaybeNull<CustomPartsImgListItem>): string => {
    const {category, door_type, gola, door_frame_width} = room;
    try {
        const img = hover?.img ?? currentCat.img;
        let img_folder = '';
        switch (category) {
            case "Kitchen": {
                let door_type_folder = door_type;
                if (door_type === "No Doors") {
                    img_folder = `${category}/Regular Kitchen/${door_type_folder}/${img}`;
                    break;
                }
                if (door_type === "Shaker" && Number(door_frame_width) >= 2) {
                    door_type_folder = "Five Piece Shaker";
                }
                const is_folder_is_gola = currentCat.type === 'gola';
                const category_type = getGolaCategoryName(category, is_folder_is_gola);
                const gola_folder_type = getGolaFolder(gola);
                const sub_folder = is_folder_is_gola ? `${category_type}/${gola_folder_type}` : `${category_type}`;
                img_folder = `${category}/${sub_folder}/${door_type_folder}/${img}`;
                break
            }
            default: {
                img_folder = img;
                break
            }
        }
        return require(`./../assets/img/categories/${img_folder}`)
    } catch (e) {
        return noImg
    }
}

const getGolaFolder = (gola: MaybeEmpty<GolaType>): 'Black' | 'Wood' | 'Aluminum' => {
    if (!gola) return 'Aluminum';
    switch (gola) {
        case "Black Matte Gola":
            return 'Black';
        case "Wood Gola":
            return 'Wood';
        default:
            return 'Aluminum'
    }
}

export const getImgSize = (category: string): 's' | 'm' | 'l' => {
    let imgSize: 's' | 'm' | 'l';
    switch (category) {
        case "Tall Cabinets":
        case "Gola Tall Cabinets":
        case "Standard Tall Cabinets":
            imgSize = 'm';
            break;
        default:
            imgSize = 's';
            break;
    }
    return imgSize
}

export const getAttributesWithoutDesc = (attributes: AttrItemType[]): AttrWithoutDescType[] => {
    return attributes.filter(el => !el.desc && el.values) as AttrWithoutDescType[]
}

export const getAttributes = (attributes: AttrItemType[], type: productTypings = 1) => {
    const attributesWithoutDescription = getAttributesWithoutDesc(attributes);
    return attributesWithoutDescription.filter(el => el.name !== 'Door').map(attribute => {
        const val: valueItemType = attribute.values.find(v => v.type === type) || attribute.values[0]
        return {
            name: attribute.name,
            value: val.value
        }
    })
}

export function isCustomPart(product: ProductOrCustomType): product is CustomPartType {
    return product.product_type === 'custom';
}

export function isCartCustomPartType(values: CartItemFrontType | CustomPartFormType): values is CartItemFrontType {
    return '_id' in values;
}

export const getProductImage = (room: RoomType, product: ProductOrCustomType, values: ProductFormType | CustomPartFormType): string => {
    if (isCustomPart(product)) {
        const customValues = values as CustomPartFormType;
        return getCustomPartImagePath(product, customValues)
    } else {
        const {hinge_opening, corner} = values as ProductFormType;
        return getProductImagePath(room, product, hinge_opening ?? corner);
    }
}

export const getCartImagePath = (room: RoomNewType, product: ProductOrCustomType, values: CartAPI): string => {
    if (isCustomPart(product)) {
        const customPartData = getCustomPartInitialTableData(product, room);
        const initialCustomPartValues = getCustomPartInitialFormValues(customPartData, values);
        return getCustomPartImagePath(product, initialCustomPartValues)
    } else {
        return getProductImagePath(room, product, values.hinge ?? values.corner);
    }
}


const getRoomCategoryByProductCategory = (prod_cat: productCategory): MaybeEmpty<RoomCategoriesType> => {
    switch (prod_cat) {
        case "Base Cabinets":
        case 'Wall Cabinets':
        case 'Tall Cabinets':
        case 'Gola Base Cabinets':
        case 'Gola Wall Cabinets':
        case 'Gola Tall Cabinets':
        case 'Standard Base Cabinets':
        case 'Standard Wall Cabinets':
        case "Standard Gola Wall Cabinets":
        case 'Standard Tall Cabinets':
            return "Kitchen";
        case "Vanities":
        case "Floating Vanities":
        case "Gola Floating Vanities":
        case 'Standard Vanities':
        case 'Standard Floating Vanities':
            return "Vanity"
        case "Build In":
            return "Build In Closet"
        case "Leather":
            return "Leather Closet"
        case "Cabinet System Closet":
            return "Cabinet System Closet"
    }
    return ''
}

export const getProductImagePath = (room: RoomNewType, product: ProductOrCustomType, hinge_type?: MaybeUndefined<hingeTypes>, has_glass_door?: boolean): string => {
    const {door_type, category} = room;
    if (isCustomPart(product)) {
        // extra RO/Drawer
        return getProductImg(`Custom Parts`, product.name.replace('/', ' '));
    } else {
        const {category: product_subcategory, name, extra_categories} = product;

        const img_src = getProductImgSrc(name, hinge_type);
        let category_folder = extra_categories ? getRoomCategoryByProductCategory(product_subcategory) : category;
        let material_folder = '';
        switch (category) {
            case "Vanity": {
                switch (product_subcategory) {
                    case "Tall Cabinets":
                    case "Gola Tall Cabinets":
                    case "Standard Tall Cabinets": {
                        category_folder = 'Kitchen';
                        break;
                    }
                }
                break
            }
            case "Build In Closet":
            case "Leather Closet":
            case "RTA Closet":
            case "Cabinet System Closet": {
                return getProductImg(category_folder, img_src[0], img_src[1]);
            }
        }
        switch (door_type as MaybeEmpty<DoorTypesType>) {
            case "Slab":
            case "No Doors":
            case "Slatted":
            case "Three Piece Door":
                material_folder = 'Slab';
                break
            case "Standard Size Shaker":
                material_folder = 'Shaker Standard';
                break;
            case "Custom Painted":
                material_folder = 'Shaker Custom';
                break;
            case "Shaker":
                material_folder = 'Shaker Micro';
                break;
            case "":
        }
        let extra_folder = '';

        // for one special category so far
        if (has_glass_door) {
            if (['Standard Gola Wall Cabinets', 'Standard Wall Cabinets'].includes(product_subcategory)) extra_folder = '/glass';
        }

        return getProductImg(`${category_folder}/${material_folder}/${product_subcategory}${extra_folder}`, img_src[0], img_src[1]);
    }
}


export const getCustomPartImagePath = (product: CustomPartType, values: CustomPartFormType): string => {
    const {type} = product;
    const {drawer_accessories, glass_door} = values
    switch (type) {
        case "drawer-inserts": {
            if (!drawer_accessories?.inserts) break;
            const {insert_type, box_type, color} = drawer_accessories.inserts
            if (!box_type || !color) return getProductImg(`Custom Parts`, product.name);
            switch (box_type) {
                case "Inserts": {
                    if (!insert_type) return getProductImg(`Custom Parts`, product.name);
                    return getImg('drawer_inserts', `Type ${insert_type} ${color}.jpg`)
                }
                case "Pegs":
                    return getImg('drawer_pegs', `Pegs ${color}.jpg`)
                case "Spice":
                    return getImg('drawer_spice', `Spice ${color}.jpg`)
            }
            break
        }
        case "glass-door": {
            if (!glass_door || !glass_door[0]) break;
            return getImg('glass_door_profile', `${glass_door[0]}.jpg`);
        }
        case "ro_drawer":
            return getProductImg(`Custom Parts`, product.name.replace('/', ' '));
    }
    return getProductImg(`Custom Parts`, product.name);
}

export function getSelectValfromVal(val: string | undefined, options: optionType[]): MaybeNull<optionType> {
    const option = options.find(el => el.value === val)
    return option || null
}

export function getSelectDoorVal(val: string | undefined, options: optionTypeDoor[]): optionTypeDoor | null {
    const option = options.find(el => el.label === val)
    return option ?? null
}

export const getCartTotal = (cart: MaybeNull<CartItemFrontType[]>): number => {
    if (!cart) return 0;
    return +(cart.reduce(
        (acc, currentVal) => acc + (currentVal.price * currentVal.amount), 0
    )).toFixed(1)
}

export const getFraction = (numberFraction: number): string => {
    return new Fraction(numberFraction).simplify(0.001).toFraction(true);
}

export const hasSideWidth = (id: number): boolean => {
    //RTA Cabinets
    return [507, 508, 509].includes(id)
}

function getBlindArr(category: string, product_id: number, isBlind: boolean): MaybeUndefined<number[]> {
    if (!isBlind) return undefined;
    type rangeType = {
        [key: string]: number
    }
    const range: rangeType = settings.blindRange;
    //Wall corner Exceptions
    const wallProductExceptionsArr: number[] = [109, 110, 113, 114];
    if (wallProductExceptionsArr.includes(product_id)) return [13, 0];
    // Base Cabinet Exceptions
    const baseProductExceptionsArr: number[] = [23, 24, 25, 26, 51, 52];
    if (baseProductExceptionsArr.includes(product_id)) return [24, 0];
    if (hasSideWidth(product_id)) return [14, 18, 22, 0];
    return range[category] ? [range[category], 0] : [0];
}

export function getHingeArr(doorArr: number[], product_id: number, width: number, height: number, product_type: ProductApiType): string[] {
    const [left, right, double, left_2, right_2, single_left, single_right, four] = hingeArr;
    let arr: hingeTypes[] = [];
    const no_hinge: number[] = [5, 6, 7, 42, 43, 44, 104, 105, 108, 208, 211, 216];
    const tall_type_1: number[] = [201, 202, 203, 204, 214, 215];
    const tall_type_2: number[] = [212, 213];
    const tall_type_3: number[] = [205, 206];
    const tall_type_4: number[] = [217, 218, 219, 220];
    const tall_type_exceptions = tall_type_1.concat(tall_type_2, tall_type_3, tall_type_4);
    const isStandard = product_type === 'standard';
    if (no_hinge.includes(product_id)) return arr;
    // exceptions in standard products
    if (isStandard) {
        if (product_id === 101 && width === 24 && height >= 36) return [double];
        if ([106, 107].includes(product_id) && width <= 21) arr.push(left, right);
    }
    // Tall Cabinets
    if (tall_type_exceptions.includes(product_id)) {
        let tallArr: hingeTypes[] = []
        if (!isStandard) {
            if (tall_type_1.includes(product_id)) {
                if (doorArr.includes(2)) tallArr.push(left_2, right_2, single_left, single_right);
                if (doorArr.includes(4)) tallArr.push(double, four)
            } else if (tall_type_2.includes(product_id)) {
                if (doorArr.includes(1)) tallArr.push(left, right);
                if (doorArr.includes(2)) tallArr.push(four);
            } else if (tall_type_3.includes(product_id)) {
                tallArr.push(left_2, right_2, single_left, single_right)
            } else if (tall_type_4.includes(product_id)) {
                tallArr.push(left, right)
            }
        } else {
            if (tall_type_1.includes(product_id)) {
                if (doorArr.includes(2)) tallArr.push(left_2, right_2);
                if (doorArr.includes(4)) tallArr.push(four)
            } else if (tall_type_3.includes(product_id)) {
                if (doorArr.includes(2)) tallArr.push(left_2, right_2);
            }
        }
        return tallArr;
    }
    // Basic
    if (doorArr.includes(1)) arr.push(left, right);
    if (doorArr.includes(2)) arr.push(double);
    if (doorArr.includes(4) && !doorArr.includes(2)) arr.push(double, four)
    return arr;
}

export const getProductById = (id: MaybeUndefined<number>, isProductStandard: boolean): MaybeNull<ProductType | CustomPartType> => {
    let product_or_custom = getProductOrCustomType(id, isProductStandard)
    if (!product_or_custom) return null;
    const {product_type} = product_or_custom as ProductOrCustomType;
    switch (product_type) {
        case "cabinet":
        case "standard": {
            const product = product_or_custom as ProductType;
            const {category, isBlind = false, hasCornerSideWidth = false} = product;
            return {
                ...product,
                blindArr: getBlindArr(category, product.id, isBlind || hasCornerSideWidth),
            }
        }
        case "custom": {
            return product_or_custom as CustomPartType;
        }
    }
}

export const getProductOrCustomType = (id: MaybeUndefined<number>, isProductStandard: boolean) => {
    if (!id) return null;
    const products = cabinets.filter(p => p.id === id);
    if (!products) return null;
    if (products.length === 1) return products[0];
    return products.find(product => product.product_type !== (isProductStandard ? "cabinet" : "standard"));
}

export const getProductsByCategory = (is_standard: boolean, category: productCategory): ProductType[] => {
    const filtered_by_product_categories = cabinets.filter(el => el.category === category || (el.extra_categories && el.extra_categories.includes(category))) as ProductType[];
    if (is_standard) {
        const excludeInStandardShakerCabinets = [211, 309];
        //
        // return filtered_by_product_categories.filter(el => el.product_type === 'standard' && !excludeInStandardShakerCabinets.includes(el.id));
        return filtered_by_product_categories.filter(el => !excludeInStandardShakerCabinets.includes(el.id));
    }
    return filtered_by_product_categories.filter(el => el.product_type === 'cabinet');
}


export const getCustomParts = (room: RoomType, customPartType: "Standard Parts" | "Custom Parts"): CustomPartDataType[] => {
    const {category, door_type} = room;

    const customParts = cabinets.filter(el => el.product_type === 'custom') as ProductOrCustomType[];
    const standardPartIds = [919, 920, 921, 924, 925];
    switch (customPartType) {
        case 'Standard Parts':
            return customParts.filter(el => standardPartIds.includes(el.id)) as CustomPartDataType[];
        case "Custom Parts":
            let exceptionIds = standardPartIds;
            const is_standard_shaker = door_type === 'Standard Size Shaker';
            const is_painted = door_type === 'Custom Painted';
            const is_rta = category !== 'RTA Closet';

            if (is_standard_shaker) exceptionIds.push(910, 913);
            if (!is_painted) exceptionIds.push(930);
            if (is_rta) exceptionIds.push(923);

            return customParts.filter(el => !exceptionIds.includes(el.id)) as CustomPartDataType[];
    }
}

export const getInitialMaterialArrayData = (custom: CustomPartType, materials: RoomMaterialsFormType): MaybeNull<materialsCustomPart> => {
    const {materials_array, id} = custom;
    const {door_finish_material, door_type, category, box_material} = materials;
    const isRoomStandard = findIsRoomStandard(door_type);
    const filtered_materials_array = filterCustomPartsMaterialsArray(materials_array, id, isRoomStandard)
    if (!filtered_materials_array) return null;
    const byBoxMaterial = getIsRTAorSystemCloset(category);
    const filteredName = filtered_materials_array.find(el => door_finish_material.includes(el.name) || door_type === el.name)
    if (filteredName) return filteredName
    if (byBoxMaterial) return filtered_materials_array.find(el => el.name === box_material) || null;
    if (door_type === "Custom Painted") return filtered_materials_array.find(el => el.name === "Painted") || null;
    if (door_finish_material.includes('Ultrapan')) return filtered_materials_array.find(el => el.name === "Luxe") || null;

    return filtered_materials_array[0];
}

export const filterCustomPartsMaterialsArray = (materials_array: MaybeUndefined<materialsCustomPart[]>, custom_part_id: number, is_standard: boolean): MaybeNull<materialsCustomPart[]> => {
    if (!materials_array) return null;
    // Standard shaker Catalog -> Custom parts exceptions for materials list(in detailed page)
    const id_exceptions_arr: number[] = [903, 905, 901, 900, 906, 907];
    if (!is_standard || !id_exceptions_arr.includes(custom_part_id)) return materials_array;

    const materials_filter_names: string[] = ['Ultrapan PET', 'Painted']
    return materials_array.filter(el => materials_filter_names.includes(el.name))
}

export const getInitialDepth = (productRange: productRangeType, isAngle: AngleType, depth: number): number => {
    const tableDepth = productRange?.depthRange[0];
    if (tableDepth) return tableDepth;
    return !isAngle ? depth : productRange.widthRange[0]
}

export const getLimit = (d: MaybeUndefined<number[]>): number => {
    return d ? d[0] : 0
}

export const checkDimensionsStandard = (productRange: productRangeType, width: number, height: number, depth: number, isAngle: MaybeUndefined<AngleType>): IsStandardDimentionsType => {
    return {
        width: checkWidthStandard(productRange, width),
        height: checkHeightStandard(productRange, height),
        depth: checkDepthStandard(productRange, depth, isAngle)
    }
}

export const checkWidthStandard = (productRange: productRangeType, width: number): boolean => {
    return productRange.widthRange.includes(width)
}
export const checkHeightStandard = (productRange: productRangeType, height: number): boolean => {
    return productRange.heightRange.includes(height)
}
export const checkDepthStandard = (productRange: productRangeType, depth: number, isAngle: MaybeUndefined<AngleType>): boolean => {
    return !isAngle ? productRange.depthRange.includes(depth) : true;
}
export const checkBlindStandard = (isBlind: boolean, blind_width: number, blindArr?: number[]): boolean => {
    if (!isBlind) return true;
    return blindArr ? blindArr.includes(blind_width) : false;
}
export const checkMiddleSectionStandard = (middleSectionDefault: MaybeUndefined<number>, middle_section: number): boolean => {
    if (!middleSectionDefault) return true;
    return middle_section === middleSectionDefault;
}
export const checkFarmSinkStandard = (heightDefault: MaybeUndefined<number>, height: MaybeUndefined<number>): boolean => {
    if (!heightDefault || !height) return true;
    return heightDefault === height;
}
export const checkOptionsSelected = (options: string[]): boolean => {
    return !options.length
}
export const checkLedSelected = (led: MaybeUndefined<string[]>): boolean => {
    return !led?.length
}
export const checkFinishedSidesStandard = (sides: MaybeUndefined<FinishSidesTypes[]>): boolean => {
    return !(sides && sides.length)
}

export function isEmptyOrZeroValue(value: any): boolean {
    if (value === undefined || value === null) return true;
    if (value === "") return true;
    if (value === 0) return true;

    if (Array.isArray(value)) {
        return value.length === 0 || value.every(isEmptyOrZeroValue);
    }

    if (typeof value === "object") {
        return Object.values(value).every(isEmptyOrZeroValue);
    }

    return false;
}

export const addProductToCart = (product: ProductType, values: ProductFormType, room_id: string, productEditId: MaybeUndefined<string>): CartAPI => {
    const {id, product_type} = product
    const {
        width,
        blind_width,
        height,
        depth,
        custom_depth,
        hinge_opening,
        finish_sides,
        corner,
        options: chosenOptions,
        glass_door,
        glass_shelf,
        note,
        led,
        custom,

        // Excluded in standard cabinet
        custom_width,
        custom_height,
        custom_blind_width,
        middle_section,
        amount,
        farm_sink_height_string
    } = values;

    const realW = width || +custom_width || 0;
    const realH = height || +custom_height || 0;
    const realD = depth || +custom_depth || 0;
    const realMiddle = +middle_section || 0
    const realBlind = +blind_width || +custom_blind_width || 0;
    const sinkHeight = farm_sink_height_string ? NumericQuantityRounded(farm_sink_height_string) : undefined;
    const sinkAPI = sinkHeight ? {
        farm_height: sinkHeight
    } : undefined

    const ledAPI = led.border.length ? {
        border: led.border,
        alignment: led.alignment,
        indent: NumericQuantityRounded(led.indent_string),
    } : undefined

    const glassAPI = chosenOptions.includes('Glass Door') || chosenOptions.includes('Glass Shelf') ? {
        door: chosenOptions.includes('Glass Door') ? glass_door : undefined,
        shelf: chosenOptions.includes('Glass Shelf') && !!glass_shelf ? glass_shelf : undefined,
    } : undefined


    const customAPI: MaybeUndefined<CartCustomTypeAPI> = custom && !isEmptyOrZeroValue(custom) ? {
        accessories: custom.closet_accessories ? {
            closet: custom.closet_accessories
        } : undefined,
        jewelery_inserts: custom.jewelery_inserts?.length ? custom.jewelery_inserts : undefined,
        mechanism: custom?.mechanism,
        extra_rollouts: !isEmptyOrZeroValue(custom.extra_rollouts) ? custom.extra_rollouts : undefined
    } : undefined

    return {
        _id: productEditId ?? '',
        room_id,
        product_id: id,
        product_type: product_type,
        amount,
        width: realW,
        height: realH,
        depth: realD,
        blind_width: realBlind,
        middle_section: realMiddle,
        hinge: hinge_opening,
        finish_sides: finish_sides.length ? finish_sides : undefined,
        corner: corner,
        options: chosenOptions,
        glass: glassAPI,
        led: ledAPI,
        sink: sinkAPI,
        note: note || undefined,
        custom: customAPI
    }
}

export const addToCartCustomPartAPI = (values: CustomPartFormType, product: CustomPartType, room_id: string, productEditId: MaybeUndefined<string>): CartAPI => {
    let {
        width,
        height,
        depth,
        material,
        note,
        glass_door,
        glass_shelf,
        door_accessories,
        led_accessories,
        standard_doors,
        standard_panels,
        rta_closet_custom,
        groove,
        drawer_accessories,
        panel_accessories,
        led,
        amount,
        shelves,
        painted_molding
    } = values;

    const {id, product_type, name} = product;

    // Update L-Shape
    if (name === 'L Shape') {
        const min = Math.min(width, height);
        const max = Math.max(width, height);
        width = min;
        height = max;
    }

    let preparedProduct: CartAPI = {
        _id: productEditId ?? '',
        room_id,
        product_id: id,
        product_type: product_type,
        amount,
        width: width,
        height: height,
        depth: depth,
        blind_width: 0,
        middle_section: 0,
        hinge: "",
        corner: "",
        options: [],
        note: note || undefined
    }

    function forceSetPath<T extends object>(
        obj: T,
        path: string,
        value: any
    ): void {
        const keys = path.split('.');
        let current: any = obj;

        for (let i = 0; i < keys.length - 1; i++) {
            const key = keys[i];

            if (current[key] === undefined || typeof current[key] !== 'object') {
                current[key] = {};
            }

            current = current[key];
        }

        current[keys[keys.length - 1]] = value;
    }

    // Glass
    if (glass_door && (!!glass_door[0] || !!glass_door[1])) forceSetPath(preparedProduct, 'glass.door', glass_door);
    if (glass_shelf) forceSetPath(preparedProduct, 'glass.shelf', glass_shelf);

    if (material) forceSetPath(preparedProduct, 'custom.material', material);

    // LED Accessories
    if (led_accessories) {
        const {
            alum_profiles,
            gola_profiles,
            transformer_100_W,
            transformer_dimmable_96_W,
            remote_control,
            door_sensor_single,
            door_sensor_double
        } = led_accessories;

        const alum_profiles_api = alum_profiles.map(el => ({
            length: el.length,
            qty: el.qty
        }));
        const gola_profiles_api = gola_profiles.map(el => ({
            length: el.length,
            qty: el.qty,
            color: el.color
        }));

        if (alum_profiles_api.length) forceSetPath(preparedProduct, 'custom.accessories.led.alum_profiles', alum_profiles_api);
        if (gola_profiles_api.length) forceSetPath(preparedProduct, 'custom.accessories.led.gola_profiles', gola_profiles_api);
        if (transformer_dimmable_96_W) forceSetPath(preparedProduct, 'custom.accessories.led.transformer_dimmable_96_W', transformer_dimmable_96_W);
        if (transformer_100_W) forceSetPath(preparedProduct, 'custom.accessories.led.transformer_100_W', transformer_100_W);
        if (remote_control) forceSetPath(preparedProduct, 'custom.accessories.led.remote_control', remote_control);
        if (door_sensor_single) forceSetPath(preparedProduct, 'custom.accessories.led.door_sensor_single', door_sensor_single);
        if (door_sensor_double) forceSetPath(preparedProduct, 'custom.accessories.led.door_sensor_double', door_sensor_double);
    }

    //Door Accessories
    if (door_accessories) forceSetPath(preparedProduct, 'custom.accessories.door', door_accessories.filter(el => el.qty > 0));

    // Standard panels
    if (standard_panels) {
        const {standard_panel, shape_panel, wtk, crown_molding} = standard_panels;
        const standard_panel_api = standard_panel.map(el => ({qty: el.qty, name: el.name}));
        const shape_panel_api = shape_panel.map(el => ({qty: el.qty, name: el.name}));
        const wtk_api = wtk.map(el => ({qty: el.qty, name: el.name}));
        if (standard_panel_api.length) forceSetPath(preparedProduct, 'custom.standard_panels.standard_panel', standard_panel_api);
        if (shape_panel_api.length) forceSetPath(preparedProduct, 'custom.standard_panels.shape_panel', shape_panel_api);
        if (wtk_api.length) forceSetPath(preparedProduct, 'custom.standard_panels.wtk', wtk_api);
        if (crown_molding) forceSetPath(preparedProduct, 'custom.standard_panels.crown_molding', crown_molding);
    }

    if (standard_doors) forceSetPath(preparedProduct, 'custom.standard_doors', standard_doors.filter(el => el.qty > 0 && el.name));


    // RTA
    if (rta_closet_custom) {
        const rta_closet_custom_api: RTAClosetAPIType[] = rta_closet_custom.map(el => ({
            qty: el.qty,
            name: el.name,
            width: el.width
        }))
        if (rta_closet_custom_api.length) forceSetPath(preparedProduct, 'custom.rta_closet', rta_closet_custom_api)
    }

    //Groove
    if (groove) {
        forceSetPath(preparedProduct, 'custom.groove', groove);
    }

    //Drawer Inserts + RO Drawers
    if (drawer_accessories) {
        forceSetPath(preparedProduct, 'custom.drawer_accessories', drawer_accessories);
    }

    // Panel accessories
    forceSetPath(preparedProduct, 'custom.panel_accessories', panelAccessoriesAPI(panel_accessories));

    //LED Block
    const ledAPI = led.border.length ? {
        border: led.border,
        alignment: led.alignment,
        indent: NumericQuantityRounded(led.indent_string),
    } : undefined
    if (ledAPI) forceSetPath(preparedProduct, 'led', ledAPI);

    if (shelves.has_shelves) {
        forceSetPath(preparedProduct, 'custom.shelves', {
            qty: shelves.qty,
            index: Number(shelves.index),
            color: shelves.color,
        });
    }

    // painted molding
    if (painted_molding) forceSetPath(preparedProduct, 'custom.painted_molding', painted_molding);

    return preparedProduct;
}


export const panelAccessoriesAPI = (panelAccessories: MaybeUndefined<PanelAccessoriesType>): MaybeUndefined<PanelAccessoriesTypeAPI> => {
    if (!panelAccessories) return undefined;
    const {hinges_or_holes, cutout, double_panel} = panelAccessories

    const result: PanelAccessoriesTypeAPI = {
        ...(hinges_or_holes?.has_hh && {
            hinges_or_holes: {
                type: hinges_or_holes.hh_type!,
                top: hinges_or_holes.hh_top!,
                bottom: hinges_or_holes.hh_bottom!,
            },
        }),
        ...(cutout?.has_cutout && {
            cutout: {
                width: cutout.width!,
                height: cutout.height!,
            },
        }),
        double_panel: double_panel ? getKeyByValue(CustomPartDoublePanel, double_panel) : undefined
    };
    return Object.keys(result).length ? result : undefined;
};

export const isHasLedBlock = (category: productCategory, door_type: MaybeEmpty<DoorTypesType>): boolean => {
    switch (door_type) {
        case "Standard Size Shaker":
            return ['Wall Cabinets', 'Leather'].includes(category);
        default:
            return ['Wall Cabinets', 'Gola Wall Cabinets', 'Leather'].includes(category);
    }
}

export const isGolaCategoryTypeShown = (category: MaybeEmpty<RoomCategoriesType>, hasGola: boolean): boolean => {
    if (!category) return false;
    return hasGola
}

export const isGolaShown = (category_gola_type: MaybeEmpty<GolaTypesType>): boolean => {
    if (!category_gola_type) return false
    return category_gola_type === "Handless Kitchen" || category_gola_type === "Gola Vanity";
}

export const isDoorTypeShown = (values: RoomMaterialsFormType, showGola: boolean): boolean => {
    const {category, category_gola_type, gola} = values;
    if (!category) return false;
    switch (category as RoomCategoriesType) {
        case "RTA Closet":
        case "Cabinet System Closet":
            return false;
        case "Kitchen":
        case "Vanity": {
            if (!category_gola_type) return false;
            return showGola ? !!gola : true
        }
        default: {
            return true
        }
    }
}

export const isGrooveShown = (door_type: MaybeEmpty<DoorTypesType>) => {
    if (door_type === 'Wood ribbed doors') return true;
    return false;
}

export const isDoorFinishShown = (values: RoomMaterialsFormType, finishArr: finishType[], showGroove: boolean): boolean => {
    const {category, door_type, groove} = values
    if (getIsRTAorSystemCloset(category)) return false;
    if (door_type === 'Standard Size Shaker') return false;
    if (showGroove && !groove) return false;
    return !!(door_type && finishArr.length)
}

export const isDoorColorShown = (values: RoomMaterialsFormType, colorArr: colorType[], showDoorFrameWidth: boolean): boolean => {
    const {category, door_type, door_finish_material, door_frame_width} = values
    if (getIsRTAorSystemCloset(category)) return false;
    if (door_type === 'Standard Size Shaker') return true;
    if (showDoorFrameWidth && !door_frame_width) return false;
    return !!(door_finish_material && colorArr.length)
}

export const isDoorFrameWidth = (values: RoomMaterialsFormType, frameArr: MaybeUndefined<materialsData[]>): boolean => {
    const {category, door_type, door_finish_material} = values;
    if (getIsRTAorSystemCloset(category)) return false;
    if (!frameArr || door_type !== 'Shaker') return false
    return !!door_finish_material
}

export const isDoorGrain = (category: MaybeEmpty<RoomCategoriesType>, door_finish_material: string, grainArr: MaybeNull<materialsData[]>): boolean => {
    if (getIsRTAorSystemCloset(category) || !door_finish_material) return false;
    return !!grainArr?.length
}

export const isBoxMaterial = (values: RoomMaterialsFormType, boxMaterialArr: finishType[], showDoorFinish: boolean, showDoorColor: boolean, showDoorGrain: boolean): boolean => {
    const {category, door_grain, door_finish_material, door_color, door_type} = values;
    if (!category || !boxMaterialArr.length) return false;
    switch (category as RoomCategoriesType) {
        case "RTA Closet":
        case "Cabinet System Closet":
            return true;
        default:
            switch (door_type as DoorTypesType) {
                case "No Doors":
                    return true;
                case "Wood ribbed doors":
                    return !!door_finish_material;
                default:
                    if (showDoorFinish && !door_finish_material) return false;
                    if (showDoorColor && !door_color) return false;
                    if (showDoorGrain && !door_grain) return false;
                    return !!door_color
            }
    }

}

export const isBoxColor = (box_material: string, isCloset: boolean): boolean => {
    if (!box_material) return false;
    return isCloset
}

export const isDrawerBrand = (box_material: string, box_color: string, isCloset: boolean): boolean => {
    if (!box_material) return false;
    return !(isCloset && !box_color);
}

export const isDrawerType = (showDrawerBrand: boolean, drawer_brand: string, drawerTypesArr: materialsData[]): boolean => {
    if (!showDrawerBrand) return false;
    return !(!drawer_brand || !drawerTypesArr.length);
}

export const isDrawerColor = (showDrawerType: boolean, drawer_type: string, drawerColorsArr: materialsData[]): boolean => {
    if (!showDrawerType) return false;
    return !(!drawer_type || drawer_type === 'Same as Box Material' || !drawerColorsArr.length);
}

export const getDrawerBrandArr = (drawers: DrawerAPIType[]): materialsData[] => {
    return drawers.map(el => ({value: el.value, img: el.img})) as materialsData[] ?? [];
}

export const getDrawerTypeArr = (drawers: DrawerAPIType[], drawer_brand: string): materialsData[] => {
    const drawerTypesArrFilter = drawers.find(el => el.value === drawer_brand)?.types;
    if (!drawerTypesArrFilter) return [];
    return drawerTypesArrFilter.map(el => ({
        value: el.value,
        img: el.img
    })) as materialsData[];
}

export const getDrawerColorArr = (drawers: DrawerAPIType[], drawer_brand: string, drawer_type: string): materialsData[] => {
    const drawerTypesArrFilter = drawers.find(el => el.value === drawer_brand)?.types;
    if (!drawerTypesArrFilter) return [];
    return drawerTypesArrFilter.find(el => el.value === drawer_type)?.colors as materialsData[] ?? [];

}

export const getDoorTypeArr = (doors: doorType[], gola: MaybeEmpty<GolaType>, isLeather: boolean): doorType[] => {
    let arr = doors.filter(el => !el.is_hide);
    if (gola) {
        arr = arr.filter(el => el.value !== 'Standard Size Shaker');
    }
    if (isLeather) {
        const exceptions = ["No Doors", "Three Piece Door", "Finger Pull", "Standard Size Shaker"]
        arr = arr.filter(el => !exceptions.includes(el.value));
    }
    return arr;
}

export const getDoorFinishArr = (doors: doorType[], door_type: MaybeEmpty<DoorTypesType>): finishType[] => {
    return [...(doors.find(el => el.value === door_type)?.finish ?? [])]
        .sort((a, b) =>
            finishNames.indexOf(a.value as FinishTypes) -
            finishNames.indexOf(b.value as FinishTypes)
        );
}

export const getFrameWidthArr = (doors: doorType[], door_type: MaybeEmpty<DoorTypesType>): materialsData[] => {
    const frames = doors.find(el => el.value === door_type)?.frame ?? [];
    return frames.filter(el => !el.is_hide).map(el => ({...el, label: getFraction(+el.value)}));
}

export const getDoorColorsArr = (doorFinishMaterial: MaybeEmpty<FinishTypes>, doorType: MaybeEmpty<DoorTypesType>, finishArr: finishType[]): colorType[] => {
    const isStandardDoor = findIsRoomStandard(doorType);
    if (isStandardDoor) return standardColors.colors as colorType[] || [];
    if (doorType === 'Custom Painted') return finishArr?.[0].colors || [];
    let colors = finishArr?.find(el => el.value === doorFinishMaterial)?.colors || [];
    colors = colors.map(el => ({
        ...el,
        label: el.value + ' ' + getMaterialColorSizesRatioString(doorFinishMaterial, el.value)
    }))
    console.log(doorFinishMaterial)
    switch (doorFinishMaterial) {
        case "Syncron":
        case "Zenit":
        case "Luxe":
        case "Finsa":
        case "Egger":
        case "Cleaf":
        case "OneSkin":
            return colors.sort((a, b) => a.value.localeCompare(b.value));
        default:
            return colors
    }
}

export const getBoxMaterialArr = <T, U>(isCloset: boolean, boxMaterial: T[], leatherBoxMaterialArr: U[]): (T | U)[] => {
    return isCloset ? leatherBoxMaterialArr : boxMaterial
}


export const getBoxMaterialColorsArr = (isLeather: boolean, isRTAorSystemCloset: boolean, boxMaterialType: string, boxMaterialsArr: finishType[], boxMaterialAPI: materialsData[]): colorType[] => {
    const colorsArr: MaybeUndefined<colorType[]> = boxMaterialsArr.find(el => el.value === boxMaterialType)?.colors;
    if (!colorsArr) return [];
    if (isLeather) return colorsArr;
    if (isRTAorSystemCloset) return boxMaterialType === 'Milino' ? boxMaterialAPI : colorsArr;
    return [];
}

export const getGrainArr = (grain: materialsData[], colorArr: colorType[], door_color: string): MaybeNull<materialsData[]> => {
    const grainType = colorArr.find(el => el.value === door_color)?.isGrain;
    switch (grainType) {
        case true:
            return grain;
        case 1:
            return grain.filter(el => el.value === 'Horizontal (Upcharge)')
        default:
            return null
    }
}

export const isLeatherType = (isLeather: boolean, isFilledDrawerBlock: boolean): boolean => {
    return isLeather && isFilledDrawerBlock
}

export const getIsFilledDrawerBlock = (drawer_type: MaybeUndefined<string>, drawer_color: MaybeUndefined<string>) => {
    if (!drawer_type) return false;
    if (drawer_type === 'Same as Box Material') return true;
    return !!drawer_color
}

export const getIsFilledLeatherBlock = (isLeather: boolean, leather: string, leather_note: string): boolean => {
    if (!isLeather || !leather.length) return false;
    return !(leather === 'Other' && leather_note.length < 3);

}

export const isLeatherNote = (showLeatherType: boolean, leather: string) => {
    return showLeatherType && leather === 'Other';
}

export const isClosetRod = (isCloset: boolean, isLeather: boolean, isFilledLeatherBlock: boolean, isFilledDrawerBlock: boolean): boolean => {
    const isFilledLast = isLeather ? isFilledLeatherBlock : isFilledDrawerBlock;
    return isCloset && isFilledLast;
}

export const checkDoors = (hingeOpening: hingeTypes): number => {
    if (!hingeOpening) return 0;
    if (hingeOpening === 'Left' || hingeOpening === 'Right' || hingeOpening === 'Single left door' || hingeOpening === 'Single right door') return 1;
    if (hingeOpening === 'Double Doors' || hingeOpening === 'Two left doors' || hingeOpening === 'Two right doors') return 2
    if (hingeOpening === 'Four doors') return 4;
    return 0
}

export const getMaterialStrings = (materials: RoomMaterialsFormType): MaterialStringsType => {
    const {name, ...data} = materials;
    const {
        category,
        gola,
        door_type,
        door_finish_material,
        door_grain,
        door_frame_width,
        door_color,
        box_material,
        box_color,
        drawer_brand,
        drawer_type,
        drawer_color,
        leather,
        leather_note,
        rod
    } = data;

    const door_color_with_sizes = door_color + ' ' + getMaterialColorSizesRatioString(door_finish_material, door_color);
    const categoryString = materialsStringify([category, gola])
    const doorString = materialsStringify([door_type, door_finish_material, door_color_with_sizes, door_grain, door_frame_width])
    const boxString = materialsStringify([box_material, box_color])
    const drawerString = materialsStringify([drawer_brand, drawer_type, drawer_color]);
    const leatherString = materialsStringify([leather, leather_note]);
    return {
        categoryString,
        boxString,
        doorString,
        drawerString,
        leatherString,
        rod
    }
}

const materialsStringify = (materialsArr: (string | number | null)[]): string => {
    return materialsArr.filter(el => !!el).join(', ')
}

export const getSquare = (doorWidth: number, doorHeight: number, product_id: number): number => {
    // Door exceptions for leather closet
    if (product_id === 413) return +((doorWidth * 26) / 144).toFixed(2)
    if (product_id === 414) return +((doorWidth * 38) / 144).toFixed(2)
    if (product_id === 415) return +((doorWidth * 29) / 144).toFixed(2)

    // Exceptions
    const noDoorsArr: number[] = [28];
    if (noDoorsArr.includes(product_id)) return 0;
    return +((doorWidth * doorHeight) / 144).toFixed(2)
}

const isWallCabinet = (category: productCategory): boolean => {
    return ["Wall Cabinets", "Gola Wall Cabinets", "Standard Wall Cabinets", "Standard Gola Wall Cabinets"].includes(category)
}

export const getWidthToCalculateDoor = (realWidth: number, blind_width: number, isAngle: MaybeUndefined<AngleType>, category: productCategory): number => {
    if (!isAngle) return realWidth - blind_width;
    // 24 is a standard blind with for corner base cabinets; 13 for wall cabines
    const blindCorner = isWallCabinet(category) ? 13.5 : 24;
    const a = realWidth - blindCorner;
    if (a <= 0) return +(Math.sqrt(2 * Math.pow(realWidth, 2))).toFixed(2);
    switch (isAngle) {
        case "flat":
            return +(Math.sqrt(2 * Math.pow(a, 2))).toFixed(2)
        case "corner":
            return a * 2;
    }
    return 0
}

export const convertCartAPIToFront = (cart: CartAPI[], room: MaybeUndefined<RoomNewType>): CartItemFrontType[] => {
    if (!room) return [];
    const cartFrontItems = cart.map(cart_item => {
        return getCartItemProduct(cart_item, room);
    })
    return cartFrontItems.filter((element): element is CartItemFrontType => element !== null)
}


export const convertRoomAPIToFront = (room: RoomType): RoomFront => {
    return {
        ...room,
        activeProductCategory: ''
    }
}

const getCartItemProduct = (item: CartAPI, room: RoomNewType): MaybeNull<CartItemFrontType> => {
    const {product_id, product_type} = item;
    const materialData = getMaterialData(room, product_id);
    const product_or_custom = getProductById(product_id, product_type === 'standard')
    if (!product_or_custom) return null;

    return {
        ...item,
        exact_image: getCartImagePath(room, product_or_custom, item),
        image_active_number: 1,
        isStandard: isStandardProductOptions(product_or_custom, item, materialData),
        price: getProductPriceAPI(item, room, materialData),
        subcategory: isCustomPart(product_or_custom) ? product_or_custom.type : product_or_custom.category,
    }
}

export const isStandardProductOptions = (product_or_custom: ProductType | CustomPartType, item: CartAPI, materialData: materialDataType): IsStandardOptionsType => {
    if (isCustomPart(product_or_custom)) {
        return setAllProductFieldIsStandard()
    } else {
        const {
            category,
            customHeight,
            customDepth,
            isAngle,
            blindArr,
            isBlind = false,
            middleSectionDefault,
            farm_sink_height
        } = product_or_custom
        const {width, height, depth, blind_width, sink, led, options, middle_section, product_id, finish_sides} = item
        const tablePriceData = getProductPriceRange(product_id, materialData);
        const productRange = getProductRange(tablePriceData, category, customHeight, customDepth);
        return {
            dimensions: checkDimensionsStandard(productRange, width, height, depth, isAngle),
            blind: checkBlindStandard(isBlind, blind_width, blindArr),
            led: checkLedSelected(led?.border),
            options: checkOptionsSelected(options),
            middle: checkMiddleSectionStandard(middleSectionDefault, middle_section),
            farm_sink: checkFarmSinkStandard(farm_sink_height, sink?.farm_height),
            finish_sides: checkFinishedSidesStandard(finish_sides)
        }
    }
}

export const getProductPriceAPI = (cart_item: CartAPI, room: RoomNewType, materialData: materialDataType): number => {
    const {product_id, product_type} = cart_item;
    const product_or_custom = getProductById(product_id, product_type === 'standard');
    if (!product_or_custom) return 0;
    if (isCustomPart(product_or_custom)) {
        return getCustomPartPrice(product_or_custom, room, cart_item);
    } else {
        const sizeLimit: MaybeUndefined<sizeLimitsType> = sizes.find(size => size.productIds.includes(product_id))?.limits;
        const tablePriceData = getProductPriceRange(product_id, materialData);
        if (!tablePriceData || !sizeLimit) return 0;
        return calculateProduct(cart_item, materialData, tablePriceData, sizeLimit, product_or_custom)
    }
}

export const setAllProductFieldIsStandard = (): IsStandardOptionsType => {
    return {
        dimensions: {
            width: true,
            height: true,
            depth: true
        },
        led: true,
        blind: true,
        middle: true,
        options: true,
        farm_sink: true,
        finish_sides: true
    }
}

export const getLEDProductCartPrice = (led: LEDAccessoriesType): number => {
    const {
        alum_profiles = [],
        gola_profiles = [],
        transformer_100_W = 0,
        transformer_dimmable_96_W = 0,
        remote_control = 0,
        door_sensor_single = 0,
        door_sensor_double = 0,
    } = led;
    const pricesAPI = settings.led_custom_part;
    const alumProfPrice = alum_profiles.reduce((acc, profile) => acc + (profile.length * pricesAPI.alum_profiles * profile.qty), 0);
    const golaProfPrice = gola_profiles.reduce((acc, profile) => acc + (profile.length * pricesAPI.gola_profiles * profile.qty), 0);
    const transformer96 = transformer_dimmable_96_W * pricesAPI.transformer_dimmable_96_W || 0;
    const transformer100Price = transformer_100_W * pricesAPI.transformer_100_W || 0;
    const remoteControlPrice = remote_control * pricesAPI.remote_control || 0;
    const doorSensorSinglePrice = door_sensor_single * pricesAPI.door_sensor_single || 0;
    const doorSensorDoublePrice = door_sensor_double * pricesAPI.door_sensor_double || 0;
    return alumProfPrice + golaProfPrice + transformer100Price + transformer96 + remoteControlPrice + doorSensorSinglePrice + doorSensorDoublePrice
}

export const isHingeHolesBlock = (id: number): boolean => {
    const IDsArr: number[] = [903];
    return IDsArr.includes(id)
}

export const isPanelCutoutBlock = (id: number): boolean => {
    const IDsArr: number[] = [903];
    return IDsArr.includes(id)
}

export const isLedBlock = (id: number): boolean => {
    const IDsArr: number[] = [903, 901, 900, 927];
    return IDsArr.includes(id)
}

export const isFullPanelBlock = (id: number): boolean => {
    const IDsArr: number[] = [905];
    return IDsArr.includes(id)
}

export const getFinishColorCoefCustomPart = (id: number, material: MaybeUndefined<string>, color: string): number => {
    switch (id) {
        case 903:
        case 904: {
            // Choose Material (In Product Page)
            if (material !== 'Milino') return 1;
            const boxColorType = getBoxMaterialColorType(color)
            return getBoxMaterialCoefByColorType(boxColorType);
        }
    }
    return 1;
}

export const convertDoorAccessories = (el: DoorAccessoryAPIType): DoorAccessoryType => {
    const doorAccessories = DA as DoorAccessoryFront[];
    const item = doorAccessories.find(ac => ac.value === el.value);
    if (!item) return {...doorAccessories[0], qty: el.qty}
    return {...item, qty: el.qty}
}

export const getdimensionsRow = (width: number, height: number, depth: number): string => {
    const widthPart = width ? `${getFraction(width)}"W x` : '';
    const heightPart = height ? ` ${getFraction(height)}"H` : '';
    const depthPart = depth && depth > 1 ? ` x ${getFraction(depth)}"D` : '';
    return `${widthPart}${heightPart}${depthPart}`
}

export const isShowBlindWidthBlock = (blindArr: MaybeUndefined<number[]>, product_type: ProductApiType, hasCornerSideWidth: MaybeUndefined<boolean>): boolean => {
    if (hasCornerSideWidth) return false
    return (!(product_type === 'standard' || !blindArr || !blindArr.length));
}

export const isShowMiddleSectionBlock = (middleSectionDefault: MaybeUndefined<number>, isProductStandard: boolean): boolean => {
    return !!(!isProductStandard && middleSectionDefault)
}

export const isShowHingeBlock = (hingeArr: string[]): boolean => {
    if (hingeArr.length < 2) return false;
    return true
}

export const isShowFarmSinkBlock = (options: ProductOptionsType[]): boolean => {
    return options.includes("Farm Sink")
}

export const isShowFinishSidesBlock = (category: productCategory, door_type: MaybeEmpty<DoorTypesType>): boolean => {
    switch (category) {
        case "Base Cabinets":
        case "Wall Cabinets":
        case "Tall Cabinets":
        case "Gola Base Cabinets":
        case "Gola Tall Cabinets":
        case "Vanities":
        case "Floating Vanities":
        case "Gola Floating Vanities":
        case "Cabinet System Closet":
        case "Build In":
            return true;
        case "Gola Wall Cabinets":
            if (door_type === 'Standard Size Shaker') return false;
            return true;
        default:
            return false
    }
}

export const isShowCornerSideWidthBlock = (hasCornerSideWidth: MaybeUndefined<boolean>): boolean => {
    return !!hasCornerSideWidth
}

export const getFinishSidesArr = (category: productCategory): FinishSidesTypes[] => {
    return isWallCabinet(category) ? ["Left", "Right", "Bottom"] : ["Left", "Right"];
}

export const getSliderCategories = (room: RoomType): SliderCategoriesItemType => {
    const API = categoriesData as SliderCategoriesType;
    const {category, gola, door_type} = room;
    if (door_type === 'Standard Size Shaker' && ['Kitchen', 'Vanity'].includes(category)) {
        if (category === "Kitchen") return API['Kitchen Standard'] as SliderCategoriesItemType;
        if (category === "Vanity") return API['Vanity Standard'] as SliderCategoriesItemType;
        return API['Standard Door'] as SliderCategoriesItemType;
    }
    switch (category) {
        case "Kitchen":
            return !gola ? API['Kitchen'] : API['Kitchen Gola'] as SliderCategoriesItemType;
        case "Vanity":
            return !gola ? API['Vanity'] : API['Vanity Gola'] as SliderCategoriesItemType;
        case "Leather Closet":
            return API['Leather Closet'] as SliderCategoriesItemType;
        case "Build In Closet":
            return API['Build In Closet'] as SliderCategoriesItemType;
        case "RTA Closet":
            return API['RTA Closet'] as SliderCategoriesItemType;
        case "Cabinet System Closet":
            return API["Cabinet System Closet"] as SliderCategoriesItemType;
    }
}

export const getCustomPartShelvesNameByIndex = (index: number): MaybeEmpty<CustomPartShelvesEnumType> => {
    if (index in CustomPartShelves) return CustomPartShelves[index as keyof typeof CustomPartShelves];
    return '';
}

export const isShowShelvesBlock = (id: number): boolean => {
    const arr: number[] = [900];
    return arr.includes(id)
}
export const formatDateToTextShort = (dateApi: Date): string => {
    const date = new Date(dateApi);
    const options: Intl.DateTimeFormatOptions = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    };
    return new Intl.DateTimeFormat('ru-RU', options).format(date);
}

export function prepareToSelectField(arr: (string | optionType)[]): optionType[] {
    return arr.map(el => {
        if (typeof el !== 'string') return el;
        return {
            value: el,
            label: el
        }
    })
}

export const getProfileList = (is_custom: boolean): optionType[] => {
    const profile = settings['Glass']['Profile'];
    const profileFiltered = is_custom ? profile.filter(el => el.value !== 'Wood Shaker') : profile;
    return prepareToSelectField(profileFiltered.map(el => el.value));
}

export const getGlassTypeList = (): optionType[] => {
    return prepareToSelectField(['Glass', 'Mirror']);
}

export const getColorsList = (glassType: string): optionType[] => {
    switch (glassType) {
        case 'Glass':
            return prepareToSelectField(settings.Glass.Glass);
        case 'Mirror':
            return prepareToSelectField(settings.Glass.Mirror);
        default:
            return []
    }
}

export const getHeightRange = (heightRange: number[], isProductStandard: boolean, width: number, tablePriceData: pricePart[], category: productCategory, customHeight: MaybeUndefined<number>) => {
    if (!isProductStandard) return heightRange.concat([0]);
    if (customHeight) return [customHeight];
    return getHeightRangeBasedOnCurrentWidth(tablePriceData, width) ?? getCabinetHeightRangeBasedOnCategory(category)
}

export const getHeightRangeBasedOnCurrentWidth = (tablePriceData: pricePart[], width: number): MaybeNull<number[]> => {
    const isHeightData = tablePriceData.find((el) => el.height);
    if (!isHeightData) return null;
    let arr: number[] = []
    tablePriceData.forEach((el) => {
        if (el.height && el.width === width) arr.push(el.height);
        arr.sort((a, b) => a - b)
    })
    return [...new Set<number>(arr)];
}

export const getCabinetHeightRangeBasedOnCategory = (category: productCategory): number[] => {
    switch (category) {
        case 'Base Cabinets':
        case "Vanities":
        case "Floating Vanities":
        case "Gola Floating Vanities":
        case "Gola Base Cabinets":
        case "Standard Base Cabinets":
        case "Standard Vanities":
        case "Standard Floating Vanities":
            return [34.5];
        case "RTA Closets":
            return [95]
        case "Cabinet System Closet":
            return [96]
        default:
            return []
    }
}

export function textToLink(text: MaybeUndefined<string>) {
    if (!text) return '';
    // Transliterate using Intl (works well for many non-Latin scripts)
    const transliterated = text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    // Convert to lowercase and replace non-alphanumeric characters with hyphens
    return transliterated
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanum with hyphen
        .replace(/^-+|-+$/g, '')     // Remove leading/trailing hyphens
        .replace(/-+/g, '-');        // Replace multiple hyphens with one
}

export const checkoutCartItemWithImg = (cart: MaybeNull<CartItemFrontType[]>, room: RoomFront) => {
    if (!cart) return [];
    return cart.map(el => {
        const {product_id, product_type} = el
        const product = getProductById(product_id, product_type === 'standard');
        if (!product) return el;
        const img = getCartImagePath(room, product, el);
        return ({...el, exact_image: img})
    })
}

export const findIsRoomStandard = (door_type: MaybeEmpty<DoorTypesType>): boolean => {
    return door_type === 'Standard Size Shaker'
}

export const findHasGolaTypeByCategory = (category: MaybeEmpty<RoomCategoriesType>): boolean => {
    return ['Kitchen', 'Vanity'].includes(category)
}

export const filterGolaTypeArrByCategory = (category: MaybeEmpty<RoomCategoriesType>, arr: materialsData[]): materialsData[] => {
    if (!category) return [];
    return arr.filter(el => el.value.includes(category)) ?? [];
}

export const getUniqueNames = (array_of_objects_with_name_field: PurchaseOrderType[] | RoomFront[], exclude?: string): string[] => {
    const converted = array_of_objects_with_name_field.map(el => {
        return el.name.trim().toLowerCase()
    });
    const excluded = exclude ? converted.filter(el => textToLink(el) !== exclude) : converted;
    excluded.push('new')
    return excluded;
}

export const createOrderFormData = async (po_rooms_api: RoomOrderType[], blob: Blob, values: CheckoutFormType, fileName: string, date: string): Promise<FormData> => {
    const rooms = po_rooms_api.map(room => {
        const {_id, purchase_order_id, carts, ...materials} = room;
        const cartFront = convertCartAPIToFront(carts, room);
        const cart_orders: CartOrder[] = cartFront.map((el) => {
            const {subcategory, isStandard, image_active_number, _id, room_id, ...cart_order_item} = el;
            return cart_order_item;
        })
        return {
            materials,
            orders: cart_orders
        }
    })
    const dataToJSON = {
        date,
        contact: values,
        rooms
    };
    return await formData(blob, fileName, dataToJSON, values)
}

export const createOrderFormRoomData = async (room: RoomFront, cart_items: CartItemFrontType[], blob: Blob, values: CheckoutFormType, fileName: string, date: string): Promise<FormData> => {
    const {_id, purchase_order_id, activeProductCategory, name, ...materials} = room;
    const cart_orders: CartOrder[] = cart_items.map((el) => {
        const {subcategory, isStandard, image_active_number, _id, room_id, ...cart_order_item} = el;
        return cart_order_item;
    })

    const dataToJSON = {
        date,
        contact: values,
        rooms: [{
            materials,
            orders: cart_orders
        }]
    };
    return await formData(blob, fileName, dataToJSON, values)
}


async function formData(blob: Blob, fileName: string, dataToJSON: DataToJSONType, values: CheckoutFormType): Promise<FormData> {
    const formData = new FormData();
    const pdfFile = new File([blob], `${fileName}.pdf`, {type: "application/pdf"});
    const jsonBlob = new Blob([JSON.stringify(dataToJSON)]);
    const jsonFile = new File([jsonBlob], `${fileName}.json`, {type: 'application/json'});
    const additionalEmailsString = values.additional_emails ? values.additional_emails.join(', ') : '';
    formData.append("pdf", pdfFile);
    formData.append("json", jsonFile);
    formData.append("client_email", values.email);
    formData.append("additional_emails", additionalEmailsString);
    formData.append("manager_email", values.manager_email ?? '');
    formData.append("client_name", values.name);
    formData.append("client_purchase_order", values.purchase_order);
    formData.append("client_room_name", values.room_name);
    if (values.files?.length) {
        values.files.forEach(file => {
            formData.append("attachments", file);
        });
    }
    return formData
}


export const getProductInitialTableData = (product: ProductType, materials: RoomMaterialsFormType, activeCat: MaybeEmpty<productCategory>): MaybeUndefined<ProductTableDataType> => {
    const {
        id: product_id,
        category,
        customHeight,
        customDepth,
        middleSectionDefault,
        blindArr,
        isCornerChoose,
        isBlind = false,
        isAngle
    } = product
    const materialData = getMaterialData(materials, product_id);
    const tablePriceData = getProductPriceRange(product_id, materialData);
    const productRange = getProductRange(tablePriceData, activeCat || category as productCategory, customHeight, customDepth);
    const sizeLimit = getSizeLimitsFromData(product_id, isAngle);
    const middleSectionNumber = middleSectionDefault ?? 0;
    const middleSection = middleSectionNumber ? getFraction(middleSectionNumber) : '';
    const blindWidth = blindArr ? blindArr[0] : '';
    const corner = isCornerChoose ? 'Left' : '';
    const productPriceData = getProductDataToCalculatePrice(product, materials);
    if (!sizeLimit || !tablePriceData || !productRange.widthRange.length) return undefined
    return {
        materialData,
        tablePriceData,
        widthRange: productRange.widthRange,
        heightRange: productRange.heightRange,
        depthRange: productRange.depthRange,
        sizeLimit,
        middleSectionNumber,
        middleSection,
        blindWidth,
        corner,
        isBlind,
        productPriceData
    }
}

export const ledEmpty: LEDType = {
    border: [],
    alignment: '',
    indent_string: '',
    indent: ''
}

export const shelvesEmpty: CustomPartShelvesType = {
    has_shelves: false,
    qty: 0,
    color: ''
}

export const getProductInitialFormValues = (productData: ProductTableDataType, cartItemValues: MaybeUndefined<CartItemFrontType>, product: ProductType): ProductFormType => {
    const {
        widthRange,
        heightRange,
        depthRange,
        middleSection,
        middleSectionNumber,
        corner: cornerTable,
        isBlind,
        blindWidth,
        tablePriceData,
    } = productData
    if (!cartItemValues) {
        return {
            width: widthRange[0],
            blind_width: blindWidth,
            height: heightRange[0],
            depth: depthRange[0],
            custom_width_string: '',
            custom_blind_width_string: '',
            custom_height_string: '',
            custom_depth_string: '',
            custom_width: '',
            custom_blind_width: '',
            custom_height: '',
            custom_depth: '',
            middle_section_string: middleSection,
            middle_section: middleSectionNumber,
            doors_amount: 0,
            hinge_opening: '',
            finish_sides: [],
            corner: cornerTable,
            options: [],
            led: ledEmpty,
            glass_door: ['', '', ''],
            glass_shelf: '',
            farm_sink_height_string: '',
            image_active_number: 1,
            custom: null,
            note: '',
            price: 0,
            amount: 1,
        }
    }
    const {
        width,
        height,
        depth,
        blind_width,
        price,
        note,
        image_active_number,
        corner,
        led,
        glass,
        hinge,
        middle_section,
        options,
        custom,
        amount,
        sink,
        finish_sides
    } = cartItemValues;

    const {customHeight, customDepth, category, isAngle, blindArr} = product;
    const productRange = getProductRange(tablePriceData, category, customHeight, customDepth);
    const isStandardWidth = checkWidthStandard(productRange, width)
    const isStandardHeight = checkHeightStandard(productRange, height)
    const isStandardDepth = checkDepthStandard(productRange, depth, isAngle)
    const isBlindStandard = checkBlindStandard(isBlind, blind_width, blindArr)
    const doors = checkDoors(hinge);

    let customVal: MaybeNull<ProductExtraType> = null;
    if (custom) {
        const {accessories, mechanism, extra_rollouts} = custom;
        if (mechanism) customVal = {mechanism: custom.mechanism};
        if (accessories?.closet) customVal = {closet_accessories: accessories.closet};
        if (extra_rollouts) customVal = {extra_rollouts};
    }

    const farmSink = sink?.farm_height ? getFraction(sink.farm_height) : '';

    return {
        width: isStandardWidth ? width : 0,
        blind_width: isBlindStandard ? blind_width : "",
        height: isStandardHeight ? height : 0,
        depth: isStandardDepth ? depth : 0,
        custom_width_string: !isStandardWidth ? getFraction(width) : '',
        custom_blind_width_string: !isBlindStandard ? getFraction(blind_width) : "",
        custom_height_string: !isStandardHeight ? getFraction(height) : '',
        custom_depth_string: !isStandardDepth ? getFraction(depth) : '',
        custom_width: !isStandardWidth ? width : '',
        custom_blind_width: !isBlindStandard ? blind_width : "",
        custom_height: !isStandardHeight ? height : '',
        custom_depth: !isStandardDepth ? depth : '',
        middle_section_string: getFraction(middle_section),
        middle_section: middle_section,
        doors_amount: doors,
        hinge_opening: hinge,
        finish_sides: finish_sides ?? [],
        corner,
        options,
        led: led ? {
            border: led.border,
            alignment: led.alignment,
            indent_string: getFraction(led.indent),
        } : ledEmpty,
        glass_door: glass?.door || [],
        glass_shelf: glass?.shelf || '',
        image_active_number: image_active_number,
        custom: customVal,
        farm_sink_height_string: farmSink,
        note: note || '',
        price,
        amount
    }
}

const getInitialSizes = (customPart: CustomPartType, initialMaterialData: MaybeNull<materialsCustomPart>, materials: RoomMaterialsFormType): InitialSizesType => {
    const {width, height, depth, width_range, height_range, initial_width, initial_height, id} = customPart;
    const sizeLimit = getCustomPartMaterialsArraySizeLimits(id, initialMaterialData?.name, materials);
    const w = initial_width ?? width ?? (width_range ? getLimit(width_range) : getLimit(sizeLimit?.width));
    const h = initial_height ?? height ?? (height_range ? getLimit(height_range) : getLimit(sizeLimit?.height));
    const d = initialMaterialData?.depth ?? depth ?? getLimit(sizeLimit?.depth);
    return {
        initial_width: w,
        initial_height: h,
        initial_depth: d
    }
}

export const getCustomPartInitialTableData = (custom_part: CustomPartType, materials: RoomMaterialsFormType): CustomPartTableDataType => {
    const initialMaterialData = getInitialMaterialArrayData(custom_part, materials);
    const initialSizes = getInitialSizes(custom_part, initialMaterialData, materials);
    const isDoorAccessories = ["door-accessories"].includes(custom_part.type);
    const isStandardPanel = ["standard-panel"].includes(custom_part.type);
    const isLEDAccessories = ["led-accessories"].includes(custom_part.type);
    const isStandardDoor = ['standard-doors', 'standard-glass-doors'].includes(custom_part.type);

    const initialDoorAccessoriesData: MaybeNull<DoorAccessoryType[]> = isDoorAccessories ? initialDoorAccessories : null;
    const initialStandardPanelsData = isStandardPanel ? initialStandardPanels : null;
    const initialLEDAccessoriesData = isLEDAccessories ? initialLEDAccessories : null;

    const standardDoorData = isStandardDoor ?
        custom_part.type === 'standard-doors' ?
            settings.StandardDoorSizes as DoorSizesArrType[] :
            settings.glassDoorSizes as DoorSizesArrType[] :
        null;

    return {
        initialMaterialData,
        initialSizes,
        initialDoorAccessories: initialDoorAccessoriesData,
        initialStandardPanels: initialStandardPanelsData,
        initialLEDAccessories: initialLEDAccessoriesData,
        standardDoorData
    }
}

export const getSchemaRootValues = (context: TestContext<AnyObject>) => {
    return context.options?.context ?? context.from?.[context.from.length - 1]?.value;
}

export const testMinMaxCustomLimit = (val: MaybeUndefined<string>, context: TestContext<AnyObject>, min: number, max: number) => {
    if (!val) return false;
    const numberVal = NumericQuantityRounded(val);
    if (isNaN(numberVal)) return context.createError({message: `Type error. Example: 12 3/8`});
    if (numberVal < min) return context.createError({message: `Minimum ${min} inches`})
    if (numberVal > max) return context.createError({message: `Maximum ${max} inches`})
    return true;
}

export const getCustomPartInitialFormValues = (customPartData: CustomPartTableDataType, cartItemValues: MaybeUndefined<CartAPI>): CustomPartFormType => {
    const {
        initialSizes,
        initialMaterialData,
        initialDoorAccessories,
        initialStandardPanels,
        initialLEDAccessories,
        standardDoorData
    } = customPartData;
    const {initial_width, initial_height, initial_depth} = initialSizes
    if (!cartItemValues) {
        return {
            width_string: getFraction(initial_width),
            height_string: getFraction(initial_height),
            depth_string: getFraction(initial_depth),
            width: initial_width,
            height: initial_height,
            depth: initial_depth,
            material: initialMaterialData?.name || '',
            glass_door: ['', '', ''],
            glass_shelf: '',
            led_accessories: initialLEDAccessories,
            door_accessories: initialDoorAccessories,
            standard_doors: null,
            standard_panels: initialStandardPanels,
            rta_closet_custom: [],
            groove: null,
            drawer_accessories: null,
            panel_accessories: {
                hinges_or_holes: {
                    has_hh: false,
                },
                cutout: {
                    has_cutout: false
                }
            },
            led: ledEmpty,
            shelves: shelvesEmpty,
            painted_molding: null,
            note: '',
            amount: 1,
            price: 0
        }
    } else {
        const {width, height, depth, custom, note, glass, amount, led: ledBlock} = cartItemValues;

        let LEDAccessoriesValues: MaybeNull<LedAccessoriesFormType> = null;
        let doorAccessoriesValues: MaybeNull<DoorAccessoryType[]> = null;
        let standardDoorValues: MaybeNull<DoorType[]> = null;
        let rtaClosetValues: MaybeNull<RTAPartCustomType[]> = null;
        const doorAccessories = DA as DoorAccessoryFront[]

        let hhValues: HingesOrHolesType = {
            has_hh: false
        }
        let cutoutValues: PanelCutoutType = {
            has_cutout: false
        }

        let doublePanelValues = undefined;

        let shelvesValues: CustomPartShelvesType = {
            has_shelves: false,
        }

        let paintedMoldingValues = null

        if (custom) {
            const {
                accessories,
                standard_doors,
                rta_closet,
                panel_accessories,
                shelves: shelvesAPI,
                painted_molding
            } = custom;

            if (accessories) {
                const {led, door} = accessories;
                if (led) {
                    const {
                        alum_profiles,
                        gola_profiles,
                        transformer_100_W,
                        transformer_dimmable_96_W,
                        remote_control,
                        door_sensor_single,
                        door_sensor_double
                    } = led
                    LEDAccessoriesValues = {
                        alum_profiles: alum_profiles ? alum_profiles.map(el => ({
                            qty: el.qty,
                            length_string: getFraction(el.length),
                            length: el.length
                        })) : [],
                        gola_profiles: gola_profiles ? gola_profiles.map(el => ({
                            qty: el.qty,
                            length_string: getFraction(el.length),
                            length: el.length,
                            color: el.color
                        })) : [],
                        transformer_100_W: transformer_100_W ?? 0,
                        transformer_dimmable_96_W: transformer_dimmable_96_W ?? 0,
                        door_sensor_double: door_sensor_double ?? 0,
                        door_sensor_single: door_sensor_single ?? 0,
                        remote_control: remote_control ?? 0
                    }

                }
                if (door) {
                    doorAccessoriesValues = doorAccessories.map(el => {
                        const {value, id, price, label, filter} = el;
                        let qty: number = 0;
                        qty = door.find(el => el.value === value)?.qty ?? 0;
                        return {
                            id,
                            label,
                            filter,
                            price,
                            value,
                            qty
                        }
                    })
                }
            }

            if (standard_doors && standardDoorData) {
                standardDoorValues = standard_doors.map(el => ({
                    ...el, name: standardDoorData.find(d => d.width === el.width && d.height === el.height)?.value || ''
                }));
            }
            if (rta_closet) {
                rtaClosetValues = rta_closet.map(el => ({
                    ...el,
                    width_string: getFraction(el.width)
                }))
            }

            if (panel_accessories) {
                const {hinges_or_holes, cutout, double_panel} = panel_accessories
                const hasHH = !!hinges_or_holes;
                const hasCutout = !!cutout
                if (hasHH) {
                    hhValues = {
                        has_hh: hasHH,
                        hh_type: hinges_or_holes?.type,
                        hh_top: hinges_or_holes?.top,
                        hh_bottom: hinges_or_holes?.bottom,
                        hh_top_string: getFraction(hinges_or_holes?.top || 0),
                        hh_bottom_string: getFraction(hinges_or_holes?.bottom || 0),
                    }
                }
                if (hasCutout) {
                    cutoutValues = {
                        has_cutout: hasCutout,
                        width: cutout?.width,
                        height: cutout?.height,
                        width_string: getFraction(cutout?.width || 0),
                        height_string: getFraction(cutout?.height || 0)
                    }
                }
                if (double_panel) {
                    doublePanelValues = getValueByKey(CustomPartDoublePanel, double_panel)
                }
            }

            if (shelvesAPI) {
                shelvesValues = {
                    has_shelves: true,
                    qty: shelvesAPI.qty || 0,
                    index: shelvesAPI.index || 0,
                }
            }

            if (painted_molding) paintedMoldingValues = painted_molding;
        }

        return {
            width_string: getFraction(width),
            height_string: getFraction(height),
            depth_string: getFraction(depth),
            width,
            height,
            depth,
            material: custom?.material ?? '',
            glass_door: glass?.door ?? ['', '', ''],
            glass_shelf: glass?.shelf ?? '',
            led_accessories: LEDAccessoriesValues,
            door_accessories: doorAccessoriesValues,
            standard_doors: standardDoorValues,
            standard_panels: custom?.standard_panels ?? null,
            rta_closet_custom: rtaClosetValues,
            groove: custom?.groove ?? null,
            drawer_accessories: custom?.drawer_accessories ?? null,
            panel_accessories: {
                hinges_or_holes: hhValues,
                cutout: cutoutValues,
                double_panel: doublePanelValues
            },
            led: ledBlock ? {
                border: ledBlock.border,
                alignment: ledBlock.alignment,
                indent_string: getFraction(ledBlock.indent)
            } : ledEmpty,
            shelves: shelvesValues,
            painted_molding: paintedMoldingValues,
            amount,
            note: note || '',
            price: 0,
        }
    }
}

export const getBorderOptionsById = (id: number): BorderType[] => {
    switch (id) {
        case 408:
        case 409:
        case 410:
        case 411:
        case 413:
        case 414:
        case 416:
            return ['Sides', 'Top', 'Bottom']
        case 901:
        case 927:
            return ['LED Shelf'];
        case 903:
            return ['LED Panel'];
        default:
            return ['Sides', 'Top', 'Bottom Inside', 'Bottom Outside']
    }
}

export const getLedWidth = (width: number, rodQty: number): number => {
    if (!rodQty) return width;
    return width * rodQty;
}

export const getLedHeight = (height: number, id: number): number => {
    switch (id) {
        case 409:
        case 416:
            return height - 73;
        case 413:
            return height - 26;
        case 414:
            return height - 47;
    }
    return height;
}

export const getIsRTAorSystemCloset = (category: MaybeEmpty<RoomCategoriesType>): boolean => {
    if (!category) return false;
    return category === 'RTA Closet' || category === 'Cabinet System Closet'
}

export const getIsLeatherOrRTAorSystemCloset = (category: MaybeEmpty<RoomCategoriesType>): boolean => {
    if (!category) return false;
    return category === 'Leather Closet' || category === 'RTA Closet' || category === 'Cabinet System Closet'
}

export const getIsLeatherCloset = (category: MaybeEmpty<RoomCategoriesType>): boolean => {
    if (!category) return false;
    return category === 'Leather Closet';
}

export const getIsSystemCloset = (category: MaybeEmpty<RoomCategoriesType>): boolean => {
    if (!category) return false;
    return category === 'Cabinet System Closet';
}

export const getIsLeatherOrSystemCloset = (category: MaybeEmpty<RoomCategoriesType>): boolean => {
    if (!category) return false;
    return category === 'Leather Closet' || category === 'Cabinet System Closet';
}

export const getIsCloset = (category: MaybeEmpty<RoomCategoriesType>): boolean => {
    switch (category) {
        case "Cabinet System Closet":
        case "RTA Closet":
        case "Build In Closet":
        case "Leather Closet":
            return true;
        case "Kitchen":
        case "Vanity":
        case "":
            return false
    }
}

export function glassDoorHasProfile(id: number): boolean {
    return id !== 913;
}

export function capitalize(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

export function toPlural(word: string): string {
    if (word.endsWith('f')) return word.slice(0, -1) + 'ves';
    if (word.endsWith('fe')) return word.slice(0, -2) + 'ves';
    if (word.endsWith('y')) return word.slice(0, -1) + 'ies';
    return word + 's';
}

export function pluralizeName(name: string, oneOf: string[]): string {
    for (const word of oneOf) {
        const regex = new RegExp(word, 'i');
        if (regex.test(name)) {
            const plural = capitalize(toPlural(word));
            return name.replace(regex, plural);
        }
    }
    return name;
}


export const getCustomPartMaterialsArraySizeLimits = (id: number, material: MaybeUndefined<CustomPartMaterialsArraySizeLimitsType>, materials: RoomMaterialsFormType): MaybeUndefined<materialsLimitsType> => {
    const color = getIsRTAorSystemCloset(materials.category) ? materials.box_color : materials.door_color;
    const is_special_milino = ["Desert Oak", "White Oak", "White Gloss", "Brown Oak", "Glacier Oak", "Grey Woodline", "Ivory Woodline", "Sable Wood", "Ultra Matte White", "Ultra Matte Grey", "Ultra Matte Volcano"].includes(color)
    const checkMilino = (direction: 'width' | 'height', limits: materialsLimitsType): materialsLimitsType => {
        const milino_max = 107.5;
        return is_special_milino ?
            {
                ...limits,
                [direction]: limits[direction]
                    ? [...limits[direction]!.slice(0, -1), milino_max]
                    : undefined,
            } : limits
    }
    switch (id) {
        case 903:
        case 904: {
            switch (material) {
                case "Milino":
                    return checkMilino('height', {width: [2.5, 48], height: [2.5, 96]})
                case "Plywood":
                    return {width: [2.5, 48], height: [2.5, 96]};
                case "Luxe":
                case "Zenit":
                case "Egger":
                case "Cleaf":
                case "Syncron":
                case "Ultrapan PET":
                case "Ultrapan Acrylic":
                case "Wood Veneer":
                case "Finsa":
                case "OneSkin":
                    return {width: [2.5, 48], height: [2.5, 108]};
                case "Painted":
                    return {width: [2.5, 48], height: [2.5, 120]};
                case "StyleLite":
                    return {width: [2.5, 47.5], height: [2.5, 95.5]};
            }
            break;
        }
        case 906:
        case 907: {
            switch (material) {
                case "Milino":
                    return checkMilino('height', {width: [3, 48], height: [6, 96], depth: [4, 48]});
                case "Plywood":
                    return {width: [3, 48], height: [6, 96], depth: [4, 48]};
                case "Luxe":
                case "Zenit":
                case "Syncron":
                case "Ultrapan PET":
                case "Ultrapan Acrylic":
                case "Wood Veneer":
                case "Finsa":
                case "Egger":
                case "Cleaf":
                case "OneSkin":
                case "StyleLite":
                    return {width: [3, 48], height: [6, 108], depth: [4, 48]};
                case "Painted":
                    return {width: [3, 48], height: [6, 120], depth: [4, 48]};
            }
            break;
        }
        case 928: {
            return {width: [12, 48]}
        }
        case 900: {
            switch (material) {
                case "Milino":
                    return checkMilino('height', {width: [6, 96], height: [6, 96], depth: [6, 96]})
                case "Plywood": {
                    return {width: [6, 96], height: [6, 96], depth: [6, 96]}
                }
                case "Luxe":
                case "Zenit":
                case "Syncron":
                case "Finsa":
                case "Egger":
                case "Cleaf":
                case "OneSkin":
                case "Ultrapan PET":
                case "Ultrapan Acrylic":
                case "Wood Veneer":
                case "StyleLite": {
                    return {width: [6, 108], height: [6, 108], depth: [6, 108]}
                }
                case "Painted": {
                    return {width: [6, 120], height: [6, 120], depth: [6, 120]}
                }
            }
            break;
        }
        case 905: {
            switch (material) {
                case "Milino":
                    return checkMilino('height', {width: [2.5, 96], height: [2.5, 96]});
                case "Plywood":
                    return {width: [2.5, 96], height: [2.5, 96]};
                case "Luxe":
                case "Zenit":
                case "Syncron":
                case "Ultrapan PET":
                case "Ultrapan Acrylic":
                case "Wood Veneer":
                case "Finsa":
                case "Egger":
                case "Cleaf":
                case "OneSkin":
                case "StyleLite":
                    return {width: [2.5, 108], height: [2.5, 108]};
                case "Painted":
                    return {width: [2.5, 120], height: [2.5, 120]};
            }
            break;
        }
        case 927: {
            switch (material) {
                case "Milino":
                    return checkMilino('width', {width: [5, 96], depth: [5, 24]})
                case "Painted":
                    return {width: [5, 120], depth: [5, 24]}
                default:
                    return {width: [5, 107.5], depth: [5, 24]}
            }
        }
        case 901: {
            switch (material) {
                case "Milino":
                    return checkMilino('width', {width: [3, 96], height: [3, 6], depth: [3, 48]})
                case "Syncron":
                case "Finsa":
                case "Luxe":
                case "Zenit":
                case "Egger":
                case "Cleaf":
                case "OneSkin":
                case "Ultrapan PET":
                case "Ultrapan Acrylic":
                case "Wood Veneer":
                case "StyleLite": {
                    return {width: [3, 108], height: [3, 6], depth: [3, 48]}
                }
                case "Painted": {
                    return {width: [3, 120], height: [3, 6], depth: [3, 48]}
                }
            }
            break
        }
        case 909: {
            return {width: [3, 48], height: [3, 96]}
        }
        case 910: {
            switch (material) {
                case "Milino":
                case "Syncron":
                case "Luxe":
                case "Zenit":
                case "Finsa":
                case "Egger":
                case "OneSkin":
                case "Cleaf": {
                    return {width: [5, 108], height: [5, 108]}
                }
                case "Painted":
                case "Wood Veneer":
                case "StyleLite": {
                    return {width: [5, 120], height: [5, 120]}
                }
            }
            break
        }
        case 911:
        case 912: {
            switch (material) {
                case "Milino": {
                    return checkMilino('height', {width: [4, 108], height: [4, 108]})
                }
                default:
                    return {width: [4, 108], height: [4, 108]};
            }
        }

        case 926: {
            return {width: [4, 108], height: [4, 108]};
        }
        case 913: {
            return {width: [5, 108], height: [5, 108]};
        }
        case 914: {
            return {width: [6, 108], height: [6, 108]};
        }
        case 915: {
            return {width: [1, 999]};
        }
        case 916: {
            return {width: [1, 999], height: [1, 999]};
        }
        case 924:
        case 925: {
            return {width: [6, 96], height: [6, 96]};
        }
    }
    return undefined
}


export const getGolaCategoryName = (category: MaybeEmpty<RoomCategoriesType>, hasGola: boolean): MaybeEmpty<GolaTypesType> => {
    if (hasGola) {
        switch (category) {
            case "Kitchen":
                return "Handless Kitchen"
            case "Vanity":
                return "Gola Vanity"
        }
    } else {
        switch (category) {
            case "Kitchen":
                return "Regular Kitchen";
            case "Vanity":
                return "Regular Vanity"
        }
    }
    return ""
}


export const getVariableType = (value: any) => {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    const type = typeof value;
    if (type === 'object') {
        // Distinguish between plain objects, Dates, Regex, etc.
        return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
    }
    return type;
};

export const hasGlassShelfColor = (index: MaybeUndefined<number>): boolean => {
    return index !== undefined && [3, 4].includes(+index);
}

export const prepareAdditionEmailsArrayToAPI = (emails: string[]): string[] => {
    return [...new Set(emails.filter(str => str.trim() !== ""))];
}

export const has_super_user_access = (user: UserType): boolean => {
    return user.user_type === "admin";
}

export const has_manager_access = (user: UserType): boolean => {
    return user.user_type === "manager";
}

export const mb_to_byte = (size: number): number => {
    return size * 1024 * 1024
}

export const getMaterialColorSizesRatioString = (door_finish: MaybeEmpty<FinishTypes>, door_color: string): string => {
    switch (door_finish) {
        case "":
            return "";
        case "Milino":
            switch (door_color) {
                case "Ash Melamine":
                case "Beige Linen Melamine":
                case "Grey Linen Melamine":
                case "Grey Melamine":
                case "Walnut Melamine":
                case "White Melamine":
                case "Grey Plywood":
                case "Natural":
                case "White":
                    return `(4'x8')`;

                case "White Gloss":
                case "Grey Woodline":
                case "Ivory Woodline":
                case "Brown Oak":
                case "Desert Oak":
                case "White Oak":
                case "Glacier Oak":
                case "Sable Wood":
                case "Ultra Matte White":
                case "Ultra Matte Grey":
                case "Ultra Matte Gris":
                case "Ultra Matte Cashmere":
                case "Ultra Matte Volcano":
                    return `(4'x9')`;
                default:
                    return ''
            }
        case "Ultrapan Acrylic":
            switch (door_color) {
                case "Arctic White Matte":
                case "Eclipse Grey Gloss":
                case "Hot Rod Red Gloss":
                case "Jet Black Matte":
                case "Pebble Gloss":
                case "Pebble Matte":
                case "Seal Grey Gloss":
                case "Seal Grey Matte":
                case "Black Mettalic Gloss":
                case "Champagne Mettalic Gloss":
                case "Dark Grey Mettalic Gloss":
                case "Frost White Mettalic Gloss":
                case "Silver Mettalic Gloss":
                case "Polar White Matte":
                    return `(4'x8')`;

                case "Arctic White Gloss":
                case "Comfort Grey Gloss":
                case "Comfort Grey Matte":
                case "Galactic Grey Gloss":
                case "Galactic Grey Matte":
                case "Jet Black Gloss":
                case "Polar White Gloss":
                case "Royal Blue Gloss":
                case "Champagne Mettalic Matte":
                case "Dark Grey Mettalic Matte":
                case "Diamond Mettalic Gloss":
                case "Obsidian Mettalic Gloss":
                case "Silver Mettalic Matte":
                case "Titanium Mettalic Gloss":
                    return `(4'x10')`;
                default:
                    return '';
            }
        case "Syncron":
        case "Luxe":
        case "Zenit":
        case "OneSkin":
        case "Wood Veneer":
            return `(4'x9')`;
        case "Cleaf":
        case "Egger":
            return `(5'x9')`;
        case "Finsa":
        case "StyleLite":
            return `(4'x8')`;
        case "Ultrapan PET":
            return `(4'x10')`;
    }
    return ''
}

export const notNegative = (val: number): number => {
    return Math.max(val, 0);
}

export const getDoorHeight = (product: ProductType, cart: CartAPI): number => {
    const {height, middle_section} = cart;
    const {id, legsHeight = 0} = product;
    // Exceptions
    switch (id) {
        case 413:
            return height - 28;
        case 414:
            return height - 50;
        case 605:
            return height - 50;
        case 606:
            return height - 30;
        default:
            return height - legsHeight - middle_section;
    }
}